
import { Component, Inject } from 'vue-property-decorator';
import { Navigator, Service } from '@/domain/providers';
import Services from '@/infrastructure/service';
import { Navigation } from 'zr-arch';
import { PromptLogin } from '@/views';
import Vue from 'vue';

@Component
export default class Logout extends Vue {
    @Inject(Service) service!: Services;
    @Inject(Navigator) navigator!: Navigation;

    created() {
        this.service.授权.logout(`${window.location.origin}${this.navigator.getUrl(PromptLogin)}`);
    }
}
